// extracted by mini-css-extract-plugin
export default {"candle-green":"CandleChart_candle-green__PgSTM","candle-red":"CandleChart_candle-red__wUOg2"};